import { initializeApp } from "firebase/app";
import { deleteToken, getMessaging, getToken, onMessage } from "firebase/messaging";

// Your Firebase web app config (from Firebase console)
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_APP_KEY,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Messaging service
const messaging = getMessaging(app);

// 👇 This function requests and returns the FCM token
export const requestForToken = async () => {
    try {
        const token = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY, // from Firebase Cloud Messaging > Web Push Certificates
        });

        console.log({ token });

        if (token) {
            return token;
        } else {
            return null;
        }
    } catch (err) {
        console.error("❌ Error retrieving FCM token:", err);
        return null;
    }
};

const unregisterFCM = async () => {
    try {
        const currentToken = await getToken(messaging, { vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY });

        if (currentToken) {
            await deleteToken(messaging);

            const swReg = await navigator.serviceWorker.getRegistration();
            if (swReg) {
                await swReg.unregister();
            }
        }
    } catch (err) {
        console.error("❌ Error unregistering FCM:", err);
    }
};

// Also export messaging + onMessage so other components can listen for pushes
export { messaging, onMessage, unregisterFCM };
